export const UserRole = {
    USER: "USER",
    ADMIN: "ADMIN",
} as const;

export const MemberRole = {
    TEACHER: "선생님",
    PARENT: "부모님",
} as const;
